import React from 'react';
import { ReactComponent as RefreshIcon } from './icons/refresh.svg';
import styles from './RefreshButton.module.css';

const RefreshButton = ({ disabled, onClick }) => (
  <RefreshIcon className={disabled ? styles.disabled : styles.refresh} onClick={onClick} />
);

export default RefreshButton;
